/**
 * @generated SignedSource<<75c0d100f8bbb2ce157648f21d9419fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FinancialDetailsFragment$data = {
  readonly id: string;
  readonly bank: {
    readonly bic: string;
    readonly iban: string;
  };
  readonly tax: {
    readonly taxNo: string;
    readonly ustId: string;
  };
  readonly " $fragmentType": "FinancialDetailsFragment";
};
export type FinancialDetailsFragment$key = {
  readonly " $data"?: FinancialDetailsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FinancialDetailsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FinancialDetailsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CaregiverBankAccount",
      "kind": "LinkedField",
      "name": "bank",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bic",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iban",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CaregiverTax",
      "kind": "LinkedField",
      "name": "tax",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taxNo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ustId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Caregiver",
  "abstractKey": null
};

(node as any).hash = "1098bd5a23988c1eee3aa48cbaa953f6";

export default node;
